import * as React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  ReferenceInput,
  SelectInput,
  required,
  useNotify,
} from "react-admin";
import TiptapRichTextInputField from "../../Components/TiptapRichTextInput";
import { TitleExperience } from "./Constant/Constant";
import { SourceCustomer } from "../Admin/Customer";
import { ExperienceNoteType } from "../../../src/Constants/Constant";

const ExperienceEdit = props => {
  const notify = useNotify();

  const onFailure = error => notify(error?.response?.data, { type: "warning" });

  return (
    <Edit {...props} title={TitleExperience.edit} onFailure={onFailure} mutationMode="pessimistic">
      <SimpleForm>
        <ReferenceInput
          label="Customer"
          source="customerId"
          reference={SourceCustomer}
          perPage={99999}
          sort={{ field: "id", order: "ASC" }}
          validate={[required()]}
        >
          <SelectInput optionValue="id" optionText="customerName" />
        </ReferenceInput>
        <SelectInput source="noteType" optionValue="value" optionText="noteType" choices={ExperienceNoteType} />
        <TextInput source="pn" validate={[required()]} />
        <TiptapRichTextInputField source="remark" validate={[required()]} />
        <BooleanInput source="isShownTt" initialValue={true} />
        <BooleanInput source="isShownCustomer" initialValue={false} />
      </SimpleForm>
    </Edit>
  );
};

export default ExperienceEdit;
